import React from "react";
import { Box, Typography } from "@mui/material";

export interface SidebarBrandLogoProps {
  /** サービス名ラベル（例: "物件管理", "売買仲介"） */
  label: string;
  /** サイドバー展開時のロゴ画像ソース */
  logoSrc: string;
  /** サイドバー折りたたみ時のロゴ画像ソース */
  logoCollapsedSrc: string;
}

export interface SidebarBrandLogoExpandedProps {
  label: string;
  logoSrc: string;
}

export interface SidebarBrandLogoCollapsedProps {
  logoCollapsedSrc: string;
}

/** サイドバー展開時のロゴ＋ラベル表示 */
export const SidebarBrandLogoExpanded: React.FC<SidebarBrandLogoExpandedProps> = ({
  label,
  logoSrc,
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
      mt: 2,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", height: "27px" }}>
      <img src={logoSrc} alt="Ippon Trading" style={{ height: "100%", objectFit: "contain" }} />
    </Box>
    <Box
      sx={{
        backgroundColor: "#0E9DBC",
        color: "#FFFFFF",
        borderRadius: "200px",
        px: "8px",
        py: "3px",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <Typography sx={{ fontSize: "10px", lineHeight: 1, fontWeight: 700 }}>
        {label}
      </Typography>
    </Box>
  </Box>
);

/** サイドバー折りたたみ時のロゴ表示 */
export const SidebarBrandLogoCollapsed: React.FC<SidebarBrandLogoCollapsedProps> = ({
  logoCollapsedSrc,
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
    <Box sx={{ display: "flex", alignItems: "center", height: "33px" }}>
      <img
        src={logoCollapsedSrc}
        alt="Ippon Trading"
        style={{ height: "100%", objectFit: "contain" }}
      />
    </Box>
  </Box>
);

/**
 * サイドバー用ブランドロゴの props から logo / logoCollapsed の ReactNode を生成するヘルパー。
 * Sidebar の logo / logoCollapsed に渡すのに利用する。
 */
export function getSidebarBrandLogoNodes(props: SidebarBrandLogoProps): {
  logo: React.ReactNode;
  logoCollapsed: React.ReactNode;
} {
  return {
    logo: (
      <SidebarBrandLogoExpanded label={props.label} logoSrc={props.logoSrc} />
    ),
    logoCollapsed: <SidebarBrandLogoCollapsed logoCollapsedSrc={props.logoCollapsedSrc} />,
  };
}
